import {
  ApplicationTag,
  type ApplicationType
} from "@/molecules/ApplicationTag"

import type { TFunction } from "@/hooks/useTranslation"
import type { Application } from "@/pages/DiscoveryPage/application/application-inventory/useApplicationInventory.types"

export const ApplicationStatusCell = (props: { t: TFunction }) =>
  function ApplicationStatusCellComponent(
    value: ApplicationType,
    record: Application
  ) {
    return (
      <ApplicationTag
        type={value}
        lastSeenUserLocale={record.lastSeenUserLocale}
        lastSeenRelative={record.lastSeenRelative}
        t={props.t}
      />
    )
  }
